import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import ui_settings_gen_2 from '@devices/settings/device_settings/ui_settings_gen_2.js';
import networks_gen_wall_display_xl from '@devices/settings/device_settings/networks_gen_wall_display_xl.js';
import app_setting_gen_2_no_appliance from '@devices/settings/device_settings/app_setting_gen_2_no_appliance.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2';
import settings_gen_2_wall_display from '@devices/settings/device_settings/settings_gen_2_wall_display';
import virtual_components_wall_display from '@devices/settings/device_settings/virtual_components';
import scripts_gen_2_wall_display from '@devices/settings/device_settings/scripts_gen_2_wall_display';

export default {
	name: 'ShellyWallDisplay',
	friendly_name: 'Wall Display X1i',
	reset_from_input: true,
	family: 'relay',
	isPM: false,
	modes: {
		relay: {
			channels: 1,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				// sensor_settings_wall_display,//Pako- as temporary solution i've removed sensor_settings_wall_display from the wall display x1i and x2i changed with https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/work_items/2919
				webhooks_gen_2,
				ui_settings_gen_2,
				networks_gen_wall_display_xl,
				bluetooth_gen_2,
				virtual_components_wall_display,
				scripts_gen_2_wall_display,
				app_setting_gen_2_no_appliance,
				share,
				settings_gen_2_wall_display,
			],
			notifications: ['offline', 'device_problem'],
		},
		media_player: {
			channels: 1,
			settings: [
				share,
				{
					title: 'application_settings',
					components: [
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
				{
					title: 'settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		thermostat: {
			channels: 1,
			settings: [
				share,
				{
					title: 'application_settings',
					components: [
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
				{
					title: 'settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
